import { VcfDomain } from 'pcs-domain';
import { IWldInputProductConfig } from "../wld-input-configuration-factory.service";

export class VCF_5_2_1_STANDARD_WORKLOAD implements IWldInputProductConfig{
    configuration: VcfDomain.Group={
                "groupId": "workloadDomainComponents",
                "groupName": "Workload Domain Components",
                "groupLabel": "Provide details for sizing software components for this workload domain.",
                "subGroups": [
                    {
                        "id": 0,
                        "subGroupId": "VCENTER",
                        "subGroupName": "Deploy VMware vCenter",
                        "label": "You can choose the size of vCenter for the Workload Domain. We will provide you with the sizing recommendation.",
                        "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vsphere/vsphere/8-0/release-notes/vcenter-server-update-and-patch-release-notes/vsphere-vcenter-server-80u3c-release-notes.html",
                        "documentLabel": "Learn More",
                        "isEnabled": true,
                        "isRequired": true,
                        "inputs": [
                            {
                                "id": "sizing",
                                "type": "COMPONENT_DROPDOWN",
                                "label": "Pick the appropriate size to deploy vCenter *",
                                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vsphere/vsphere/8-0/release-notes/vcenter-server-update-and-patch-release-notes/vsphere-vcenter-server-80u3c-release-notes.html",
                                "documentLabel": "Learn More",
                                "isRequired": true,
                                "isEnabled": true,
                                "default": "MEDIUM",
                                "minNumberOfVms": 0,
                                "predicate": {},
                                "options": [],
                                "componentSizing": [
                                    {
                                        "id": "TINY",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "SMALL",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "MEDIUM",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "LARGE",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "X-LARGE",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "subGroupId": "NSX-MANAGER",
                        "subGroupName": "Deploy VMware NSX Manager",
                        "label": "You can choose to have a dedicated NSX manager just for this Workload domain or you could share this with other workload domains.",
                        "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/nsx/vmware-nsx/4-2/installation-guide.html",
                        "documentLabel": "Learn More",
                        "isEnabled": true,
                        "isRequired": true,
                        "inputs": [
                            {
                                "id": "deploymentType",
                                "type": "RADIO",
                                "label": "Do you want a dedicated or a shared NSX Manager for this Workload Domain?",
                                "isRequired": true,
                                "isEnabled": true,
                                "predicate": {},
                                "default": "shared",
                                "options": [
                                    {
                                        "id": "shared",
                                        "label": "Shared"
                                    },
                                    {
                                        "id": "dedicated",
                                        "label": "Dedicated"
                                    }
                                ]
                            },
                            {
                                "id": "sizing",
                                "type": "COMPONENT_DROPDOWN",
                                "label": "Pick the appropriate size to deploy NSX Manager *",
                                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/nsx/vmware-nsx/4-2/installation-guide.html",
                                "documentLabel": "Learn More",
                                "isRequired": true,
                                "isEnabled": true,
                                "default": "SMALL",
                                "minNumberOfVms": 0,
                                "predicate": {},
                                "options": [],
                                "componentSizing": [
                                    {
                                        "id": "MEDIUM",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "LARGE",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "subGroupId": "NSX-EDGE",
                        "subGroupName": "Deploy VMware NSX Edge",
                        "label": "You can choose NSX Edge for the Workload Domain based on your throughput requirement.",
                        "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/nsx/vmware-nsx/4-2/installation-guide/installing-nsx-edge.html",
                        "documentLabel": "Learn More",
                        "isEnabled": false,
                        "isRequired": false,
                        "inputs": [
                            {
                                "id": "sizing",
                                "type": "COMPONENT_DROPDOWN",
                                "label": "Pick the appropriate size to deploy NSX Edge *",
                                "isRequired": false,
                                "isEnabled": false,
                                "default": "MEDIUM",
                                "minNumberOfVms": 0,
                                "predicate": {},
                                "options": [],
                                "componentSizing": [
                                    {
                                        "id": "SMALL",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "label": "Suggested when total throughput requirement is <2 Gbps",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "MEDIUM",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "label": "Suggested when total throughput requirement is <2 Gbps",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "LARGE",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "label": "Suggested when total throughput requirement is 2-10 Gbps",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "X-LARGE",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "label": "Suggested when total throughput requirement is >10 Gbps",
                                                "resources": {}
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": 0,
                        "subGroupId": "HCX",
                        "subGroupName": "Deploy HCX Manager",
                        "label": "This will include VCF HCX Manager, Interconnect, and Network Extension.",
                        "documentLink": "https://techdocs.broadcom.com/content/dam/broadcom/techdocs/us/en/pdf/vmware/hcx/hcx/vmware-hcx-4-11.pdf",
                        "documentLabel": "Learn More",
                        "isEnabled": false,
                        "isRequired": false,
                        "inputs": [
                            {
                                "id": "hcxComponentInfo",
                                "type": "COMPONENT_DROPDOWN",
                                "label": "",
                                "isRequired": false,
                                "isEnabled": true,
                                "default": "",
                                "minNumberOfVms": 0,
                                "predicate": {},
                                "options": [
                                    {
                                        "id": "fixed",
                                        "label": ""
                                    }
                                ],
                                "componentSizing": [
                                    {
                                        "id": "fixed",
                                        "overheads": [
                                            {
                                                "id": "HCX-MANAGER",
                                                "name": "HCX Manager",
                                                "resources": {}
                                            },
                                            {
                                                "id": "HCX-IX",
                                                "name": "HCX Interconnect",
                                                "resources": {}
                                            },
                                            {
                                                "id": "HCX-NE",
                                                "name": "HCX Network Extension",
                                                "resources": {}
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "migrateOverInternet",
                                "type": "RADIO",
                                "label": "Do you plan to migrate over the internet?",
                                "isRequired": true,
                                "isEnabled": true,
                                "predicate": {},
                                "options": [
                                    {
                                        "id": "yes",
                                        "label": "Yes"
                                    },
                                    {
                                        "id": "no",
                                        "label": "No",
                                        "isDefault": true
                                    }
                                ]
                            },
                            {
                                "id": "hcxWanSizing",
                                "type": "COMPONENT_DROPDOWN",
                                "isRequired": false,
                                "isEnabled": true,
                                "predicate": {
                                    "operator": "OR",
                                    "conditions": [
                                        {
                                            "key": "migrateOverInternet",
                                            "value": "yes",
                                            "operator": "EQUALS"
                                        }
                                    ]
                                },
                                "options": [
                                    {
                                        "id": "fixed",
                                        "label": ""
                                    }
                                ],
                                "componentSizing": [
                                    {
                                        "id": "fixed",
                                        "overheads": [
                                            {
                                                "id":"HCX-WAN",
                                                "name": "HCX WAN Optimization",
                                                "resources": {}
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "migrateNonVsphere",
                                "type": "RADIO",
                                "label": "Do you plan to migrate any non-vSphere workloads?",
                                "isRequired": true,
                                "isEnabled": true,
                                "predicate": {},
                                "options": [
                                    {
                                        "id": "yes",
                                        "label": "Yes"
                                    },
                                    {
                                        "id": "no",
                                        "label": "No",
                                        "isDefault": true
                                    }
                                ]
                            },
                            {
                                "id": "hcxSrgSizing",
                                "type": "COMPONENT_DROPDOWN",
                                "isRequired": false,
                                "isEnabled": true,
                                "minNumberOfVms": 0,
                                "predicate": {
                                    "operator": "OR",
                                    "conditions": [
                                        {
                                            "key": "migrateNonVsphere",
                                            "value": "yes",
                                            "operator": "EQUALS"
                                        }
                                    ]
                                },
                                "options": [
                                    {
                                        "id": "fixed",
                                        "label": ""
                                    }
                                ],
                                "componentSizing": [
                                    {
                                        "id": "fixed",
                                        "overheads": [
                                            {
                                                "id": "HCX-SRG",
                                                "name": "HCX Sentinel Gateway, Data Receiver, and Replication Gateway",
                                                "resources": {}
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            };
    getProductInfo(): string {
        throw new Error("Method not implemented.");
    }
    getDatabaseConnectionString(): string {
        throw new Error("Method not implemented.");
    }
    getApiEndpoint(): string {
        throw new Error("Method not implemented.");
    }
    getDeploymentStrategy(): string {
        throw new Error("Method not implemented.");
    }

}